import { render, staticRenderFns } from "./OvopExploreProvinceDashboard.vue?vue&type=template&id=7042cce1&scoped=true&"
import script from "./OvopExploreProvinceDashboard.vue?vue&type=script&lang=js&"
export * from "./OvopExploreProvinceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OvopExploreProvinceDashboard.vue?vue&type=style&index=0&id=7042cce1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042cce1",
  null
  
)

export default component.exports